import { CalendarDotsIcon } from "@phosphor-icons/react/dist/csr/CalendarDots";
import { Button } from "@volca/ui/components/ui/button";
import { PopoverTrigger } from "@volca/ui/components/ui/popover";
import { cn } from "@volca/ui/lib/utils";

interface IcmPeriodPickerTriggerProps {
  text: string | null;
  isOpen: boolean;
  disabled?: boolean;
  variant: "field" | "button";
  size: "sm" | "default" | "lg";
  className?: string;
}

export const IcmPeriodPickerTrigger = ({
  text,
  isOpen,
  disabled,
  variant,
  size,
  className,
}: IcmPeriodPickerTriggerProps) => {
  if (variant === "button")
    return (
      <PopoverTrigger
        disabled={disabled}
        render={<Button variant="ghost" size={size} className={className} />}
      >
        Change period
      </PopoverTrigger>
    );

  return (
    <PopoverTrigger
      disabled={disabled}
      render={
        <Button
          variant="outline"
          size={size}
          data-empty={!text}
          className={cn(
            "w-full justify-between font-normal data-[empty=true]:text-subtle",
            className,
          )}
        />
      }
    >
      {/* Text with a trailing calendar icon so the field reads as an
          interactive date selector, not static text. */}
      <span className="flex-1 truncate text-left" title={text ?? undefined}>
        {text ?? "Select a period"}
      </span>
      <CalendarDotsIcon
        className={cn("text-subtle", { "text-brand": isOpen })}
      />
    </PopoverTrigger>
  );
};
